/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { getLogoTitle } from '../../helpers/serviceDeskHelpers';
import { ZENDESK_SERVICEDESK_TYPE } from '../../util/channelTypes';

/**
 * A component to render a red Twilio Icon -- color can be overridden as "fill" prop.
 * @param {integer} props.size scales the result to a height of size and width of 1.32(size) to preserve aspect ratio, default 32
 * @param {Object} props the properties for this component
 * @returns {Object} the JSX for this component
 */
export const ZendeskIcon = ({ className, size = 32, ...others }) => {
  const intl = useIntl();
  return (
    <svg
      className={cx('ZendeskIcon', className)}
      viewBox="0 0 400 303"
      width={size}
      height={size}
      fillRule="evenodd"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      {...others}>
      <title>{getLogoTitle(ZENDESK_SERVICEDESK_TYPE, intl)}</title>
      <g>
        <path d="M.003 3.088c.022 23.905 12.428 50.151 31.482 66.601 46.043 39.75 116.499 25.813 143.676-28.421 5.948-11.87 9.596-26.456 9.596-38.37V0H0l.003 3.088M214.98 111.564c0 61.36.089 111.558.197 111.552.167-.01 182.999-220.605 184.385-222.468l.482-.648H214.98v111.564M92.371 191.24C41.639 252.48.092 302.684.044 302.804c-.048.12 41.492.218 92.313.218h92.4V191.459c0-61.36-.033-111.564-.073-111.564-.04 0-41.581 50.105-92.313 111.345m208.286 19.543c-47.159 3.656-83.16 40.945-85.565 88.626l-.183 3.613h185.173l-.168-4.008c-2.186-52.003-47.459-92.248-99.257-88.231" />
      </g>
    </svg>
  );
};

ZendeskIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};
